import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Sir Gingerman's Kingdom";
const PROD = "https://sirgingerman.com";
const DEFAULT_IMG = `${PROD}/og-image.png`;
const DEFAULT_DESC =
  "A gentle place for growing hearts — stories, activities and social-emotional learning for families.";

// Client-side per-page metadata: drives browser tab titles, Google (JS-rendered) and canonical URLs.
// Social crawlers (FB/X/LinkedIn) don't run JS, so they fall back to the static homepage OG.
export const Seo = ({ title, description, path = "", image, noSuffix = false }) => {
  const fullTitle = title ? (noSuffix ? title : `${title} — ${SITE}`) : SITE;
  const desc = description || DEFAULT_DESC;
  const url = `${PROD}${path}`;
  const img = image
    ? (image.startsWith("http") ? image : `${PROD}${image}`)
    : DEFAULT_IMG;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
